<template>
  <div>
    <b-modal
      id="addAttachment"
      centered
      hide-footer
      hide-header
      no-close-on-backdrop
      :visible="showAddAttachment"
      @hidden="$emit('close-modal')"
    >
      <div>
        <div class="d-flex align-items-center justify-content-between p-3">
          <div class="b-modal-header">
            {{ uploadingResume ? "Upload Resume" : "Add Attachment" }}
          </div>
          <div class="rotate-on-hover pointer">
            <img
              @click="$emit('close-modal')"
              v-b-tooltip.hover.top="'Close'"
              src="../../../assets/img/accessconnew/blueCross.svg"
              alt
            />
          </div>
        </div>
        <hr class="my-0" />

        <div class="px-4 pt-3">
          <UploadImage
            :label="uploadingResume ? 'Resume' : 'Media'"
            placeholder="Select file"
            type="upload_file"
            id="attachment"
            :maxFileSize="uploadingResume ? '5' : '10'"
            :fileFormat="uploadingResume ? ['pdf'] : acceptedFileFormat"
            :mediaType="uploadingResume ? 'resume' : 'media'"
            @select-value="previewImage"
          />
        </div>
        <div
          v-if="!uploadingResume"
          class="mt-2 lightblue-container d-flex align-items-center p-2"
        >
          <img
            src="../../../assets/new-icons/grey-info-icon.svg"
            class="mx-2"
            alt
          />
          <span> Attach any candidate-related documents or screenshots. </span>
        </div>
        <hr class="my-0" />
        <div
          :class="
            uploadingResume ? 'justify-content-end' : 'justify-content-between'
          "
          class="d-flex align-items-center p-3 w-100"
        >
          <div
            v-if="!uploadingResume"
            class="pointer"
            @click="$emit('show-add-note')"
          >
            <img
              class="mr-1"
              src="../../../assets/img/singleblueplus-icon.svg"
              alt=""
            />

            <span class="attach-font"> Add Note </span>
          </div>
          <div class="d-flex align-items-center bluebtn">
            <b-button
              class="acs-cancelBtn-modal mr-3"
              @click="$emit('close-modal')"
              >Cancel</b-button
            >
            <div class="position-relative">
              <b-button
                class="acs-addBtn-modal pl-4 pr-4"
                :class="
                  LoaderStatus ? 'send-loader-class defaultCursor' : 'pointer'
                "
                :disabled="!attachment"
                @click="attachment && submitData()"
                >{{
                  LoaderStatus ? "" : uploadingResume ? "Upload" : "Save"
                }}</b-button
              >
              <div v-if="LoaderStatus" class="send-loader-pos">
                <Loader />
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import UploadImage from "../../../components/InputComponents/UploadImage";
import {
  addNoteAndAttachment,
  patchApplyJob,
} from "../../../utils/apiFunctions";
import toast from "../../mixin/toast";
import Loader from "../../../components/fixedcomponents/Loader.vue";

export default {
  name: "AddAttachment",
  props: {
    showAddAttachment: Boolean,
    uploadingResume: Boolean,
    candidateID: String,
    email: String,
    jobID: String,
  },
  data() {
    return {
      attachment: null,
      LoaderStatus: false,
      acceptedFileFormat: ["pdf", "jpg", "jpeg", "png", "webp"],
    };
  },
  components: { UploadImage, Loader },
  created() {
    this.clearForm();
  },
  mixins: [toast],
  methods: {
    async submitData() {
      if (this.uploadingResume) await this.uploadResume();
      else await this.submitAttachment();
    },
    async uploadResume() {
      this.LoaderStatus = true;
      try {
        let form = new FormData();
        let resumeData = [{ attachmentName: "resume", fieldType: "default" }];
        form.append("email", this.email);
        form.append("jobID", this.jobID);
        form.append("resume", this.attachment);
        form.append("attachment", JSON.stringify(resumeData));
        const res = await patchApplyJob(form);
        if (res.status == 200) {
          this.dynamicToast(
            "success",
            "Successfully uploaded",
            "Resume uploaded successfully"
          );
          this.clearForm();
          this.$emit("close-modal");
          this.$emit("update-details");
        } else {
          this.errorModal("Something went wrong!");
        }
      } catch (error) {
        this.errorModal("Something went wrong!");
      } finally {
        this.LoaderStatus = false;
      }
    },
    previewImage(data) {
      this.attachment = data;
    },
    clearForm() {
      this.attachment = null;
    },
    async submitAttachment() {
      this.LoaderStatus = true;
      try {
        let form = new FormData();
        form.append("candidateID", this.candidateID);
        form.append("jobID", this.jobID);
        form.append("mediaKeys", JSON.stringify(["media"]));
        form.append("media", this.attachment);

        const res = await addNoteAndAttachment(form);
        if (res.status == 200) {
          this.dynamicToast(
            "success",
            "Successfully added",
            "Attachment added successfully"
          );
          this.clearForm();
          this.$emit("close-modal");
        } else {
          this.errorModal("Something went wrong!");
        }
        this.LoaderStatus = false;
      } catch (err) {
        this.errorModal("Something went wrong!");
        this.LoaderStatus = false;
      }
    },
  },
};
</script>

<style></style>
